import './compare-empty-card.scss';
